// src/components/Admin/tabs/DailyGuestsTable.jsx
import React, { useState, useMemo } from 'react';
import { startOfDay, totalNights } from '../adminUtils';
import { todayMX } from '../../../utils/dates';

// Todo lo que hay que mandar con el perro: los extras que agregó al reservar
// y los pedidos de la tienda pagados para entregarse con esta reservación.
const ProductsToSend = ({ booking }) => {
  const addOns = booking.addOnProducts || [];
  const storeOrders = booking.storeOrders || [];
  if (addOns.length === 0 && storeOrders.length === 0) return '—';

  return (
    <ul className="space-y-1">
      {addOns.map((item, i) => (
        <li key={`addon-${i}`} className="whitespace-nowrap">
          {item.quantity} × {item.nameAtTime || item.product?.name || 'Producto eliminado'}
        </li>
      ))}
      {storeOrders.map((order) =>
        order.items.map((item, i) => (
          <li key={`${order._id}-${i}`} className="whitespace-nowrap">
            {item.quantity} × {item.nameAtTime}{' '}
            <span className="text-[10px] font-semibold uppercase tracking-wide text-[#9A0002]/70">
              Tienda {order.orderNumber}
            </span>
          </li>
        ))
      )}
    </ul>
  );
};

const DailyGuestsTable = ({ bookings }) => {
  const [selectedDate, setSelectedDate] = useState(
    () => todayMX()
  );

  const dayBookings = useMemo(() => {
    const day = startOfDay(new Date(selectedDate + 'T00:00:00'));
    return bookings
      .filter((b) => {
        if (b.status === 'cancelled') return false;
        const inD = startOfDay(new Date(b.checkInDate));
        const outD = startOfDay(new Date(b.checkOutDate));
        return inD <= day && outD > day;
      })
      .sort((a, b) => new Date(a.checkInDate) - new Date(b.checkInDate));
  }, [bookings, selectedDate]);

  return (
    <div className="bg-white rounded-2xl border border-[#3A2A20]/10 p-6">
      <div className="flex flex-wrap justify-between items-center gap-4 mb-5">
        <div>
          <h3 className="font-['Fraunces'] text-lg font-semibold text-[#3A2A20]">
            Huéspedes por día
          </h3>
          <p className="text-xs text-[#3A2A20]/50 mt-0.5">
            {dayBookings.length} {dayBookings.length === 1 ? 'perro hospedado' : 'perros hospedados'} en esta fecha
          </p>
        </div>
        <div>
          <label className="block text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/50 mb-1">
            Ver fecha
          </label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="px-3 py-2 border border-[#3A2A20]/15 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#9A0002]/40 focus:border-[#9A0002] transition"
          />
        </div>
      </div>

      {dayBookings.length === 0 ? (
        <p className="text-sm text-[#3A2A20]/40 text-center py-10 bg-[#EFE6DD]/30 rounded-xl">
          Nadie hospedado en esta fecha.
        </p>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-[#3A2A20]/10">
          <table className="min-w-full divide-y divide-[#3A2A20]/10 text-sm">
            <thead className="bg-[#EFE6DD]/60">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Nombre</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Perro(s)</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Dirección</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">CP</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Teléfono</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Días totales</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Productos</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#3A2A20]/10 bg-white">
              {dayBookings.map((b) => {
                const addr = b.shippingAddress || {};
                return (
                  <tr key={b._id}>
                    <td className="px-4 py-3 font-medium text-[#3A2A20]">
                      {b.user?.fullname || '—'}
                    </td>
                    <td className="px-4 py-3 text-[#3A2A20]/70">
                      {b.dogs?.length > 0 ? b.dogs.map((d) => d.name).join(', ') : '—'}
                    </td>
                    <td className="px-4 py-3 text-[#3A2A20]/70">
                      {addr.direccion ? `${addr.direccion}, ${addr.colonia || ''}` : '—'}
                    </td>
                    <td className="px-4 py-3 text-[#3A2A20]/70">{addr.zipcode || '—'}</td>
                    <td className="px-4 py-3 text-[#3A2A20]/70">{addr.telefono || '—'}</td>
                    <td className="px-4 py-3 text-[#3A2A20]/70">
                      {totalNights(b.checkInDate, b.checkOutDate)}
                    </td>
                    <td className="px-4 py-3 text-[#3A2A20]/70">
                      <ProductsToSend booking={b} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DailyGuestsTable;